module.exports = __webpack_public_path__ + "static/img/programme.637a5f28.png";